import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addPatientStory } from "../../Adapters/ApiAdapter";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";

const AddPatientStory = () => {
  const [name, setName] = useState("");
  const [heading, setHeading] = useState("");
  const [review, setReview] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file)); // Preview the selected image
    }
  };

  const handleSubmit = async () => {
    if (!name || !heading || !review) {
      toast.error("Name, Heading, and Review are required!");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    // const stripHtml = (html) => html.replace(/<[^>]+>/g, "").trim();
    formData.append("name", name);
    formData.append("heading", heading);
    formData.append("review", review);
    formData.append("video_link", videoLink);

    // Append image if selected
    if (image) {
      formData.append("blog_img", image); // Ensure API supports this field
    }

    try {
      const response = await addPatientStory(formData);
      console.log("Add response:", response);
      toast.success("Patient story added successfully!");
      setTimeout(() => navigate("/patient-stories"), 2000); // Redirect after success
    } catch (err) {
      console.error("Error adding patient story:", err);
      toast.error("Failed to add patient story. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Patient Story
      </Typography>
      <Box
        display="flex"
        flexDirection="column"
        gap="16px"
        maxWidth="600px"
        mt="20px"
      >
        <TextField
          label="Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth
          required
        />
        <TextField
          label="Heading"
          variant="outlined"
          value={heading}
          onChange={(e) => setHeading(e.target.value)}
          fullWidth
          required
        />

        <Typography variant="body1">Review</Typography>
        <ReactQuill
          theme="snow"
          value={review}
          onChange={setReview}
          style={{ height: "200px", marginBottom: "50px" }}
        />

        {/* <TextField
          label="Review"
          variant="outlined"
          multiline
          rows={4}
          value={review}
          onChange={(e) => setReview(e.target.value)}
          fullWidth
          required
        /> */}
        <TextField
          label="Video Link"
          variant="outlined"
          value={videoLink}
          onChange={(e) => setVideoLink(e.target.value)}
          fullWidth
        />

        {/* Image Upload */}
        <Box mt={2}>
          <Typography variant="body1" gutterBottom>
            Upload Slider Image:
          </Typography>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {preview && (
            <Box mt={2}>
              <img
                src={preview}
                alt="Preview"
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  borderRadius: "8px",
                }}
              />
            </Box>
          )}
        </Box>

        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
            style={{background:'#0ca854'}}
          >
            {loading ? <CircularProgress size={24} /> : "Add Patient Story"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddPatientStory;
